"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const KioskHeader = (props) => (react_1.default.createElement("div", { className: "kiosk-header" },
    react_1.default.createElement("button", { id: "back-to-kiosk-btn", onClick: () => {
            props.setExternalPageOpen(false);
        } },
        react_1.default.createElement("svg", { id: "close-svg", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
            react_1.default.createElement("path", { d: "M13.41,12l6.3-6.29a1,1,0,1,0-1.42-1.42L12,10.59,5.71,4.29A1,1,0,0,0,4.29,5.71L10.59,12l-6.3,6.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l6.29,6.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z" })))));
exports.default = KioskHeader;
